module.exports = __webpack_public_path__ + "static/img/apple.53f7b25.png";